import React, {useEffect, useState, useRef, useMemo, useCallback} from 'react';
import Loading from "../../Loading";
import {sortCampaign} from "../../Utils/CommonUtils";
import {CampaignItemContext} from "../../../core/context/context";
import {Alert} from "@mui/lab";
import {useGetAllABTestsQuery} from "../../../core/reducers/abtest";
import AbtestsGroup from "./AbtestsGroup";
import {Card, Link, Menu, MenuItem} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {CSVLink} from "react-csv";


export default function ABTestFrame({
                                        env,
                                        onSelectItem,
                                        onSelectMultipleItems,
                                        filterText,
                                        selectedList,
                                        filterStatuses,
                                        rightPanel,
                                        createDisabled,
                                        dateFilter, activateAbtests
                                    }) {


    const [showAllGroups, setShowAllGroups] = useState(null);
    const [showRainbow, setShowRainbow] = useState(window.localStorage.getItem("show_rainbow_" + env) == null ? false : window.localStorage.getItem("show_rainbow_" + env) == 'true')


    const query = {}
    query.env = env
    if(dateFilter!=undefined && dateFilter.from!= '' && dateFilter.to != '') {

        query.from = Math.round(new Date(dateFilter.from).setHours(0,0,0,0)/1000);
        query.till = Math.round(new Date(dateFilter.till).setHours(23,59,59,999)/1000);

    }

    const {
        data: abtests,
        isLoading,
        isError,
        isFetching,
        error
    } = useGetAllABTestsQuery(query, {
        pollingInterval: 5000,
    });

    const abtestsByType = abtests == undefined ? [] : abtests.abtests.reduce((acc, abtest) => {
        const type = abtest.type;

        if (filterText !== '' && abtest.id.toLowerCase().indexOf(filterText.toLowerCase()) < 0) return acc;

        if (filterStatuses !== undefined && filterStatuses.length > 0) {
            if (!filterStatuses.includes(abtest.status)) return acc;
        }

        if (!acc[type]) {
            acc[type] = [];
        }
        acc[type].push(abtest);

        return acc;
    }, {});

    const allVisibleItems = useMemo(() => {
        const result = [];
        Object.keys(abtestsByType).forEach(type => {
            abtestsByType[type].forEach(item => {
                result.push({ item: item });
            });
        });
        return result;
    }, [abtestsByType]);

    const visibleIds = allVisibleItems ? allVisibleItems.map(i => i.item.id) : [];
    const selectedVisibleCount = visibleIds.filter(id => selectedList?.includes(id)).length;
    const isAllVisibleSelected = visibleIds.length > 0 && selectedVisibleCount === visibleIds.length;

    const getExpandTitle = () => {
        if(showAllGroups == true) return "expand all"
        return "collapse all"
    }

    const getRainbowTitle = () => {
        if(showRainbow == false) return "rainbow"
        return "de-rainbow"
    }

    const getSelectAllTitle = () => {
        if (isAllVisibleSelected) return "deselect all";
        return "select all";
    }

    const handleSelectAll = useCallback((isSelect) => {
        if (onSelectMultipleItems) {
            onSelectMultipleItems(allVisibleItems, isSelect);
        }
    }, [onSelectMultipleItems, allVisibleItems]);


    const prevPropsRef = useRef();
    const prevProps = prevPropsRef.current;
    useEffect(() => {

        if(prevProps==undefined || (prevPropsRef.current != env && error==undefined && !isLoading && !isFetching)) {
            prevPropsRef.current = env
        }
    }, [env, isLoading, isFetching, error]);

    const isNotError = (error==''||error==undefined) || (error?.data?.message?.indexOf('Cursor')>0 && prevPropsRef.current==env)
    const shouldShowContent = (!isLoading&&prevPropsRef.current==env || (prevPropsRef.current!=env&&!isFetching))&& isNotError &&(( !isLoading && !isError) || (prevPropsRef.current==env))
    const shouldShowLoading = ((error!=''&&error!=undefined) || isLoading || (isError && prevPropsRef.current!=env) || (isFetching && prevPropsRef.current!=env && prevPropsRef.current!=undefined))



    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            {shouldShowLoading && <Card  sx={{mt:3.5}} severity="info"><Loading env={env} isLoading={isLoading||isFetching} isError={isError} error={error} ></Loading></Card>}

            {shouldShowContent&&Object.keys(abtestsByType).length === 0 && <Alert sx={{mt:3.5}} severity="info">No AB tests</Alert>}
            {shouldShowContent&&Object.keys(abtestsByType).length > 0 && <>

                <div className="collapse-controls" style={{ display: 'flex', alignItems: 'center', paddingTop: '5px' }}>
                    <div className="collapse-all-link" onClick={() => {
                        handleSelectAll(!isAllVisibleSelected);
                    }}>
                        <div>{getSelectAllTitle()}</div>
                    </div>
                    &nbsp;
                    <div className="collapse-all-link" onClick={() => {setShowAllGroups(!showAllGroups);}}><div>{getExpandTitle()}</div></div>
                    &nbsp;
                    <div className="collapse-all-link" onClick={() => {
                        setShowRainbow(!showRainbow);
                        window.localStorage.setItem("show_rainbow_" + env, !showRainbow)
                    }}><div>{getRainbowTitle()}</div>
                    </div>

                    <div style={{marginLeft: 'auto'}}>
                        <IconButton onClick={handleMenuClick}>
                            <MoreVertIcon/>
                        </IconButton>
                        <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>

                            {env !== 'liveops' && env !== 'prod' && selectedList !== undefined &&
                                <MenuItem disabled={selectedList.length === 0} onClick={handleMenuClose}>
                                    <Link onClick={() => {
                                        activateAbtests(env)
                                    }}>Adjust Time</Link>
                                </MenuItem>
                            }
                        </Menu>
                    </div>
                </div>


                {Object.keys(abtestsByType).sort().map((type) => (
                    <CampaignItemContext.Provider
                        key={type}
                        value={{
                            env,
                            selectedList,
                            onSelectItem,
                            onSelectMultipleItems,
                            bundles: abtests.bundles,
                            createDisabled,
                            type,
                            types: abtests.types,
                            campaignType: abtests.types.filter(item => item.readableType == type)[0],
                            items: abtestsByType[type].sort(sortCampaign)
                        }}>
                        <AbtestsGroup showRainbow={showRainbow} showAllGroups={showAllGroups} rightPanel={rightPanel} />

                    </CampaignItemContext.Provider>
                ))}

            </>}
        </div>
    );
};